import request from '@/utils/request'
import { parseStrEmpty } from '@/utils/ruoyi'

// 查询用户列表分页
export function pageUser(query) {
  return request({
    url: '/system/user/page',
    method: 'get',
    params: query,
  })
}

// 查询项目用户列表分页（只查询项目主管和保洁员工）
export function pageProjectUser(query) {
  return request({
    url: '/system/user/pageProjectUser',
    method: 'get',
    params: query,
  })
}

// 查询项目佩戴人选项
export function listProjectUserOptions(query) {
  return request({
    url: '/system/user/projectUserOptions',
    method: 'get',
    params: query,
  })
}

// 查询用户列表
export function listUser(query) {
  return request({
    url: '/system/user/list',
    method: 'get',
    params: query,
  })
}

// 查询用户详细
export function getUser(userId) {
  return request({
    url: '/system/user/detail',
    method: 'get',
    params: {
      id: parseStrEmpty(userId),
    },
  })
}

// 查询项目用户详细（只返回项目主管和保洁员工角色）
export function getProjectUser(userId) {
  return request({
    url: '/system/user/detailProjectUser',
    method: 'get',
    params: {
      id: parseStrEmpty(userId),
    },
  })
}

// 新增用户
export function addUser(data) {
  return request({
    url: '/system/user/add',
    method: 'post',
    data: data,
  })
}

// 修改用户
export function updateUser(data) {
  return request({
    url: '/system/user/edit',
    method: 'post',
    data: data,
  })
}

//项目授权
export function editProjectCodes(data) {
  return request({
    url: '/system/user/editProjectCodes',
    method: 'post',
    data: data,
  })
}

//修改状态

export function editUserStatus(data) {
  return request({
    url: '/system/user/editUserStatus',
    method: 'post',
    data: data,
  })
}

// 删除用户
export function delUser(userId) {
  return request({
    url: '/system/user/' + userId,
    method: 'delete',
  })
}

// 用户密码重置
export function resetUserPwd(id, password) {
  const data = {
    id,
    password,
  }
  return request({
    url: '/system/user/resetPwd',
    method: 'put',
    data: data,
  })
}

// 用户状态修改
export function changeUserStatus(id, status) {
  const data = {
    id,
    status,
  }
  return request({
    url: '/system/user/changeStatus',
    method: 'put',
    data: data,
  })
}

// 查询用户个人信息
export function getUserProfile() {
  return request({
    url: '/system/user/profile',
    method: 'get',
  })
}

// 修改用户个人信息
export function updateUserProfile(data) {
  return request({
    url: '/system/user/profile',
    method: 'put',
    data: data,
  })
}

// 用户密码重置
export function updateUserPwd(oldPassword, newPassword) {
  const data = {
    oldPassword,
    newPassword,
  }
  return request({
    url: '/system/user/profile/updatePwd',
    method: 'put',
    params: data,
  })
}

// 用户头像上传（参数为 oss 全路径字符串）
export function uploadAvatar(data) {
  return request({
    url: '/system/user/profile/avatar',
    method: 'post',
    data,
  })
}

// 导入用户
export function importData(data) {
  return request({
    url: '/system/user/importData',
    method: 'post',
    data: data,
  })
}

// 导入项目用户数据
export function importProjectUserData(data) {
  return request({
    url: '/system/user/importProjectUserData',
    method: 'post',
    data: data,
  })
}

// 下载项目用户导入模板
export function importProjectUserTemplate(query) {
  return request({
    url: '/system/user/importProjectUserTemplate',
    method: 'post',
    params: query,
    responseType: 'blob',
  })
}

// 查询授权角色
export function getAuthRole(userId) {
  return request({
    url: '/system/user/authRole/' + userId,
    method: 'get',
  })
}

// 保存授权角色
export function updateAuthRole(data) {
  return request({
    url: '/system/user/authRole',
    method: 'put',
    params: data,
  })
}

// 查询部门下拉树结构
export function deptTreeSelect() {
  return request({
    url: '/system/user/deptTree',
    method: 'get',
  })
}

//导入项目
export function importProjectData(data) {
  return request({
    url: '/user/project-info/importData',
    method: 'post',
    data: data
  })
}
